// /app/frontend/src/features/choral-intelligence/RecommendationDetails.jsx
//
// Technical component-score panel. Hidden by default so directors see
// the human-readable explanation first; expandable for editors who
// want to inspect the raw evidence.
import React, { useState } from "react";

function toPercent(value) {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return "—";
  }
  return `${Math.round(value * 100)}%`;
}

const COMPONENT_LABELS = {
  scripture:            "Scripture",
  liturgical_moment:    "Ritual fit",
  season_feast:         "Season / feast",
  parish_capability:    "Choir fit",
  editorial_authority:  "Editorial authority",
  parish_memory:        "Parish memory",
  assembly_fit:         "Assembly fit",
  freshness:            "Freshness",
};

const COMPONENT_ORDER = [
  "scripture",
  "liturgical_moment",
  "season_feast",
  "parish_capability",
  "editorial_authority",
  "parish_memory",
  "assembly_fit",
  "freshness",
];

export default function RecommendationDetails({ ranking }) {
  const [open, setOpen] = useState(false);

  if (!ranking) {
    return null;
  }

  const components = ranking.components || {};

  return (
    <div
      className="ci-details"
      data-testid={`ci-details-${ranking.work_id}`}
    >
      <button
        type="button"
        className="ci-details__toggle"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-controls={`ci-scores-${ranking.work_id}`}
        data-testid={`ci-details-toggle-${ranking.work_id}`}
      >
        <span
          className={
            open
              ? "ci-details__toggle-chevron ci-details__toggle-chevron--open"
              : "ci-details__toggle-chevron"
          }
          aria-hidden="true"
        >
          ▸
        </span>
        {open ? "Hide component scores" : "Show component scores"}
      </button>

      {open && (
        <dl
          id={`ci-scores-${ranking.work_id}`}
          className="ci-score-grid"
          data-testid={`ci-scores-${ranking.work_id}`}
        >
          {COMPONENT_ORDER.map((key) => (
            <div key={key}>
              <dt>{COMPONENT_LABELS[key]}</dt>
              <dd data-testid={`ci-score-${key}-${ranking.work_id}`}>
                {toPercent(components[key])}
              </dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
